import './AboutSection.css';
import LuisferTrabajando from '@/assets/images/home/AboutSection/imageLuisferTrabajando.jpeg';

export default function AboutSection() {
  return (
    <section id="nosotros" className="about-section relative overflow-hidden py-24 md:py-0">
      <div className="about-divider-vertical" />
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-stretch min-h-[700px]">
          <div className="flex-1 flex flex-col justify-center py-24 lg:pr-16 order-2 lg:order-1">
            <p className="about-section-label mb-6">◆ Nuestra Historia ◆</p>
            <h2 className="about-section-title mb-8">
              Artesanía que <br /><span className="about-section-title-accent">Define tu Estilo</span>
            </h2>
            <div className="space-y-5 about-section-text">
              <p>Barber Studio Luisfer nació de una pasión genuina por el arte del barbero. Con más de una década de experiencia, Luisfer ha perfeccionado cada técnica hasta convertirla en una expresión única de <strong>maestría artesanal.</strong></p>
              <p>Aquí no se trata solo de un corte de pelo — es una <em>experiencia completa</em>. Desde el momento en que entras, cada detalle está pensado para ofrecerte el más alto nivel de servicio.</p>
              <p>Cada cliente merece un estilo que refleje su personalidad. Por eso, Luisfer dedica tiempo a entender tu visión antes de comenzar.</p>
            </div>
            <div className="mt-10 flex flex-wrap gap-8">
              {[{ icon: 'ri-award-line', text: 'Técnica certificada' }, { icon: 'ri-shield-check-line', text: 'Productos premium' }, { icon: 'ri-heart-line', text: 'Atención personalizada' }].map((item) => (
                <div key={item.text} className="about-feature">
                  <div className="about-feature-icon"><i className={`${item.icon} text-lg`} /></div>
                  <span className="about-feature-text">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="relative flex-shrink-0 lg:w-[35%] order-1 lg:order-2 h-65 lg:h-[600px] flex items-center justify-center">
            <img src={LuisferTrabajando} alt="Barbero trabajando" className="w-full h-full max-h-[500px] object-cover object-top" />
            <div className="about-image-frame" />
            <div className="about-badge">
              <p className="about-badge-value">10+</p>
              <p className="about-badge-label">Años de Experiencia</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}